// ============================================================
// Auth Store (Zustand)
// ============================================================
// Manages authentication state: user, token, role, isAuthenticated.
// Persisted to localStorage for session continuity.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import config from '@/config';

const useAuthStore = create(
  persist(
    (set) => ({
      // ── State ────────────────────────────────────
      user: null,
      token: null,
      modules: [],
      qrScannerEnabled: false,
      isAuthenticated: false,
      isSessionExpired: false,

      // ── Actions ──────────────────────────────────
      login: (user, token, modules = [], qrScannerEnabled = false) =>
        set({
          user,
          token,
          modules,
          qrScannerEnabled,
          isAuthenticated: true,
          isSessionExpired: false,
        }),

      logout: () =>
        set({
          user: null,
          token: null,
          modules: [],
          qrScannerEnabled: false,
          isAuthenticated: false,
          isSessionExpired: false,
        }),

      setModules: (modules) => set({ modules }),

      setQrScannerEnabled: (qrScannerEnabled) => set({ qrScannerEnabled }),

      setSessionExpired: (isSessionExpired) => set({ isSessionExpired }),

      setUser: (user) => set({ user }),

      updateUser: (updates) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...updates } : null,
        })),
    }),
    {
      name: config.storage.tokenKey,
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        modules: state.modules,
        qrScannerEnabled: state.qrScannerEnabled,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export default useAuthStore;
